import React from "react";
import AsyncSelect from "react-select/lib/Async";
import LoadMask from "Utils/LoadMask/LoadMask";
import { ClientesAsociadosTable } from "./ClientesAsociadosTable";
import { useConsumidorFinalForm } from "../hooks/useConsumidorFinalForm";

export const ConsumidorFinalForm = ({ idConsumidorFinal, regresar }) => {
    const consumidorFinalForm = useConsumidorFinalForm(
        idConsumidorFinal,
        regresar,
    );

    const {
        formRegister,
        errors,
        clienteSeleccionado,
        setClienteSeleccionado,
        loadClientes,
        cargando,
        AgregarCliente,
        GuardarConsumidorFinal,
    } = consumidorFinalForm;

    return (
        <LoadMask loading={cargando} blur>
            <div className="mx-auto consumidor-final-form__contenido">
                <div className="formulario-fields-row w-100 gap-1rem flex-wrap">
                    <div className="formulario-field horizontal flex-wrap gap-1rem">
                        <h4 className="text-nowrap mb-0">
                            Nombre del consumidor final:
                        </h4>
                        <div className="d-flex flex-column gap-2 flex-1 min-w-200">
                            <input
                                type="text"
                                {...formRegister("nombre", {
                                    required: "Este campo es obligatorio",
                                })}
                                className="form-control"
                                placeholder="Nombre del consumidor final"
                            />
                            {errors.nombre && (
                                <small className="text-danger ml-2">
                                    {errors.nombre.message}
                                </small>
                            )}
                        </div>
                    </div>
                </div>

                <h4 className="mb-1 mt-4 consumidor-final__titulo-separador">
                    Clientes asignados
                </h4>
                <div className="consumidor-final-form__clientes-header mt-2 mb-3">
                    <div className="formulario-field horizontal justify-content-end mt-3">
                        <h6 className="text-nowrap mb-0">Seleccionar Cliente:</h6>
                        <div className="flex-1" style={{ maxWidth: "250px" }}>
                            <AsyncSelect
                                className="react-select-container"
                                isSearchable
                                isClearable
                                cacheOptions
                                defaultOptions
                                value={clienteSeleccionado}
                                loadOptions={loadClientes}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(selected) => {
                                    setClienteSeleccionado(selected);
                                }}
                            />
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={AgregarCliente}
                    >
                        Agregar
                    </button>
                </div>

                <ClientesAsociadosTable
                    consumidorFinalForm={consumidorFinalForm}
                />

                <div className="d-flex justify-content-center gap-1rem flex-wrap mt-5 w-100">
                    <button
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={regresar}
                    >
                        Regresar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={GuardarConsumidorFinal}
                    >
                        Guardar
                    </button>
                </div>
            </div>
        </LoadMask>
    );
};
